export const en = {


  "translation": {
    "vacationContent": {"title":"Listing title","description":"Description"},
"desktopHome": {"mapTitle":"Discover properties across Tunisia","mapUnavailable":"The map is temporarily unavailable.","verified":"Verified listings","verifiedText":"Reviewed listings for greater confidence.","everywhere":"Across Tunisia","everywhereText":"Properties in every governorate.","simple":"Simple and quick","simpleText":"Find your property in a few clicks.","support":"A team ready to help","supportText":"Personal support at every step."},
"vacationPublication": {"optionalPrice":"Nightly price (optional)","invalidPrice":"Enter a valid positive price or leave this field blank.","noPrice":"Price not provided","contactForPrice":"Contact the advertiser for the price before booking.","imageLimit":"You can add up to {{count}} images.","imageCount":"{{count}} / {{max}} images"},
    "mobileFinal": {"reset":"Reset","apply":"Show results","searchPlaceholder":"City, neighbourhood or keyword","aiIntro":"Describe what you need, I’ll take care of the rest","aiExample":"E.g. 2 bedrooms in Sousse, 250,000 DT","longStay":"Sale or long-term rental","publishVacation":"Publish a holiday rental","shortStay":"Daily or holiday rental"},
    "phoneNav": {"navigation":"Main navigation","favorites":"Favorites","publish":"Post","profile":"Profile","menu":"Menu","sale":"For sale","rent":"Rentals","vacation":"Holidays","requests":"Requests"},
    "homeDestinations": { "sidiBouSaid": "Sidi Bou Said" },
    "voice": {"start":"Dictate","stop":"Stop dictation","listening":"Listening…","denied":"Microphone not allowed. You can type instead.","noSpeech":"I didn't hear anything. Please try again.","error":"Dictation didn't work. You can type instead."},
    "propertyRequest": {"notify":{"proposal":"New proposal received for one of your searches."},"nav":{"public":"Property searches","mine":"My searches","new":"New"},"home":{"title":"Can't find the right property?","lead":"Describe what you are looking for: advertisers can offer you their properties.","start":"I'm looking for a property","browse":"See the searches","resume":"Resume my search"},"new":{"title":"I'm looking for a property","subtitle":"Describe what you are looking for and Lina Immo helps you find matching listings.","draftRestored":"Your search in progress has been restored.","restart":"Start over","continue":"Continue"},"text":{"label":"Describe your search","placeholder":"I'm looking for a 200 to 300 m² plot in Sahloul, maximum budget 250,000 TND.","notice":"The free text is visible to advertisers, but some criteria mentioned only in the text may not be used in the ranking.","noContact":"Do not write an e-mail or phone number in this text: they would be hidden.","count":"{{count}} / {{max}}"},"criteria":{"title":"Criteria","required":"required","transaction":"Transaction","categories":"Property type","city":"City","chooseCity":"Choose a city","delegations":"Delegations","delegationsHint":"Optional, up to {{max}}. Without a delegation: the whole city.","addDelegation":"Add a delegation","removeDelegation":"Remove {{name}}","chooseCityFirst":"Choose a city first.","budgetMin":"Min budget ({{unit}})","budgetMax":"Max budget ({{unit}})","surfaceMin":"Min area (m²)","surfaceMax":"Max area (m²)","min":"Min","max":"Max","more":"Bedrooms and amenities","bedroomsMin":"Bedrooms (minimum)","attributes":"Amenities","landNote":"A plot of land has no bedrooms or amenities.","chooseTypeFirst":"Choose a property type first."},"transaction":{"sale":"Buy","rent":"Rent","vacation":"Holiday rental"},"transactionShort":{"sale":"Purchase","rent":"Rental","vacation":"Holidays"},"attribute":{"parking":"Parking","furnished":"Furnished","kitchen":"Kitchen","ac":"Air conditioning","pool":"Swimming pool","garden":"Garden","barbecue":"Barbecue","beachAccess":"Beach access","workspace":"Workspace","washer":"Washing machine","wifi":"Wi-Fi","tv":"TV","elevator":"Elevator","balcony":"Balcony or terrace","seaView":"Sea view"},"budgetUnit":{"sale":"TND","rent":"TND / month","vacation":"TND / night"},"preview":{"title":"Check your search","subtitle":"Nothing is published at this step. Correct anything that is not right.","text":"Your text","summary":"You are looking for:","edit":"Edit","publish":"Publish my search","publishing":"Publishing…","signInTitle":"Sign in to publish","signInText":"Your criteria stay saved in this tab while you sign in. Then come back with “Resume my search”.","signIn":"Sign in","signUp":"Create an account","lifetime":"Your search stays published for 30 days. You can edit or close it from “My searches”."},"summary":{"transaction":"Transaction","categories":"Property type","location":"Location","wholeCity":"{{city}} (whole city)","budget":"Budget","surface":"Area","bedrooms":"Bedrooms","attributes":"Amenities","text":"Free text","contact":"Contact","none":"Not specified","min":"min {{value}}","max":"max {{value}}","between":"{{min}} – {{max}}","bedroomsValue":"{{count}} minimum"},"contact":{"title":"How should we contact you?","email":"E-mail","phone":"Phone","both":"Both","prefilled":"Prefilled from your account","privacy":"Your e-mail and phone number are never shown publicly. They are only used to notify you and put you in touch."},"done":{"title":"Your search is published","text":"It stays visible until {{date}}.","mine":"See my searches","view":"See the published search","another":"New search"},"mine":{"title":"My searches","new":"New","tabActive":"Active","tabClosed":"Closed","tabExpired":"Expired","empty":"No search in this category.","published":"Published on {{date}}","expires":"expires on {{date}}","expiredOn":"expired on {{date}}","closedOn":"closed on {{date}}","proposals":"{{count}} offer(s) received","edit":"Edit","close":"Close","delete":"Delete","closeQuestion":"Close this search?","closeNote":"Advertisers will no longer see it.","deleteQuestion":"Delete this search permanently?","deleteNote":"It will disappear from your searches and from the public list.","cancel":"Cancel","closed":"Search closed.","deleted":"Search deleted.","loadMore":"Show more","retry":"Try again","loading":"Loading…"},"edit":{"title":"Edit my search","save":"Save","saving":"Saving…","saved":"Search updated.","expiryNote":"Editing does not extend the publication: it expires on {{date}}.","notEditable":"This search cannot be found or is no longer active.","back":"Back to my searches"},"list":{"title":"Property searches","subtitle":"People are looking for a property. Offer yours if it matches.","start":"I'm looking for a property","allTransactions":"All transactions","allTypes":"All types","allCities":"All cities","empty":"No search matches.","view":"See the search","previous":"Previous","next":"Next","page":"Page {{page}} of {{pages}}"},"detail":{"published":"Published on {{date}}","expires":"expires on {{date}}","description":"Description","privacy":"The contact details of the person searching are not shown.","back":"All searches"},"status":{"Active":"Active","Closed":"Closed","Expired":"Expired"},"cardTitle":"{{type}} in {{place}}","errors":{"transactionRequired":"Choose buy, rent or holiday rental.","categoryRequired":"Choose at least one property type.","categoryInvalid":"This type is not available for this transaction.","cityRequired":"Choose a city.","cityInvalid":"Unknown city.","tooManyDelegations":"5 delegations at most.","delegationInvalid":"Unknown delegation for this city.","invalidNumber":"Invalid number.","minAboveMax":"The minimum is above the maximum.","invalidBedrooms":"Invalid number of bedrooms (0 to 30).","textTooLong":"1000 characters at most.","preferenceRequired":"Choose a contact method.","emailRequired":"E-mail is required for this contact method.","emailInvalid":"Invalid e-mail.","phoneRequired":"Phone is required for this contact method.","phoneInvalid":"Invalid phone (8 to 15 digits).","fixBelow":"Correct the highlighted fields.","invalid":"Some information is invalid. Check the form.","signIn":"Sign in to continue.","forbidden":"This search does not belong to you.","notFound":"Search not found or deleted.","tooManyActive":"You already have 10 active searches. Close one before publishing a new one.","notActive":"This search is no longer active: it can no longer be edited.","tooManyCreated":"You have published 5 searches in the last hour. Please try again a little later.","tooManyRequests":"Too many requests. Try again in a moment.","tooManyRequestsWait_one":"Too many requests. Try again in one minute.","tooManyRequestsWait_two":"Too many requests. Try again in 2 minutes.","tooManyRequestsWait_few":"Too many requests. Try again in {{count}} minutes.","tooManyRequestsWait_many":"Too many requests. Try again in {{count}} minutes.","tooManyRequestsWait_other":"Too many requests. Try again in {{count}} minutes.","server":"The service is temporarily unavailable. Try again later.","alreadyProposed":"You have already offered this property.","requestClosed":"This search no longer accepts offers.","ownRequest":"You cannot offer a property to your own search.","listingNotOwned":"You can only offer your own listings.","listingNotFound":"This listing cannot be found or has been deleted.","listingMismatch":"This listing does not match the type of search.","tooManyProposals":"Too many offers sent recently. Try again later.","messageInvalid":"Message too long (500 characters at most).","chooseListing":"Choose one of your listings."},"analysis":{"button":"Analyse with Lina AI","analyzing":"Analysing…","needText":"Write your search first.","done":"Criteria detected: check them and complete if needed.","nothing":"No criteria were detected in your text. Complete the criteria below.","unavailable":"Lina AI is not available right now: only the criteria written explicitly were detected.","detected":"Detected criteria","remove":"Remove: {{label}}","manual":"Entered by you","ai":"Lina AI","auto":"Automatic text analysis","unscored":"Mentioned in your text, not used in the ranking."},"matches":{"see":"See matching listings","title":"Matching listings","loading":"Searching the listings…","strong":"Very good matches","close":"Good matches","alternative":"Alternatives","badgeStrong":"Very good match","badgeClose":"Good match","badgeAlternative":"Alternative","none":"We did not find a property matching your search closely enough.","publishQuestion":"Would you like to publish your search?","noneFit":"None of these listings suits you?","publish":"Publish my search","edit":"Edit my search","view":"See the listing","why":"Why this listing","noPhoto":"Photo not available","bedrooms":"{{count}} bedroom(s)"},"why":{"matches":"Matches {{items}}.","budget":"your budget","place":"{{place}}","surface":"the requested area","bedrooms":"the number of bedrooms","attributes":"the amenities: {{items}}","budgetAbove":"The price is {{percent}}% above your budget.","budgetBelow":"The price is {{percent}}% below your minimum budget.","priceUnknown":"The price is not given.","surfaceBelow":"The area is {{percent}}% smaller than requested.","surfaceAbove":"The area is {{percent}}% larger than requested.","surfaceUnknown":"The area is not given.","locationSameCity":"Located in {{place}}: same city, another delegation.","bedroomsMissing":"{{count}} bedroom(s) missing.","attributesMissing":"Without: {{items}}.","typeOther":"The property type is different.","locationOther":"The city is different."},"propose":{"title":"Offer a property","action":"Offer a property","choose":"Choose a property to offer","onlyOwn":"Only your active listings matching this search are listed.","none":"You have no active listing of this type.","noneFor":"You have no active “{{type}}” listing. This search is for: {{transaction}}.","createListing":"Publish a listing","select":"Select: {{title}}","message":"Message (optional)","messagePlaceholder":"Describe your property in a few words.","messageNotice":"Do not write a phone number, e-mail or link: they would be hidden. The person will contact you through Lina Immo.","submit":"Send the offer","sending":"Sending…","sent":"Your offer has been sent.","alreadyProposed":"Already offered","withdraw":"Withdraw my offer","withdrawn":"Offer withdrawn.","closed":"This search no longer accepts offers.","ownRequest":"This is your own search: you cannot offer a property to it.","scoreNotice":"The match level is computed automatically. You may offer a partial match: the person will see the differences."},"level":{"excellent":"Excellent","good":"Good","partial":"Partial"},"received":{"show":"See the offers ({{count}})","hide":"Hide the offers","title":"Offers received","newCount":"{{count}} new","newBadge":"New","none":"No offer yet.","from":"Offered by {{name}}","fromUnknown":"Offered by an advertiser","date":"on {{date}}","message":"Advertiser's message","unavailable":"This listing is no longer available.","loading":"Loading the offers…"}},
    "administration": {"visitorsTitle":"Visitors","visitorsToday":"Today","visitorsTotal":"Total since launch","visitorsLast7Days":"Last 7 days","visitorsCount":"Visitors","visitorsError":"Visitor statistics are unavailable.","listingTitle":"Title","amount":"Amount","title":"Lina Immo Administration","overview":"Dashboard","listings":"Listings","vacations":"Holiday rentals","users":"Users","reservations":"Reservations","navigation":"Administration","back":"Back to website","loading":"Loading…","denied":"Administrator access only","signIn":"Sign in","search":"Title or publisher","searchUsers":"Name or email","city":"City","delegation":"District","type":"Type","status":"Status","all":"All","active":"Published","deleted":"Deleted","sale":"Sale","rent":"Rent","night":"Holiday / night","filter":"Filter","reset":"Reset","retry":"Retry","sales":"Sales","rents":"Rentals","lands":"Land","pending":"Pending reservations","total":"{{count}} result(s)","photo":"Photo","author":"Publisher","price":"Price","date":"Date","actions":"Actions","name":"Name","email":"Email","registeredAt":"Registered","role":"Role","listingCount":"Active listings","host":"Host","traveler":"Guest","arrival":"Arrival","departure":"Departure","view":"View listing","viewAuthor":"View publisher","delete":"Delete permanently","deleteQuestion":"Permanently delete this listing?","deleteNote":"The listing will be removed from the website. Related conversation and reservation history is retained under existing rules.","cancel":"Cancel","deleting":"Deleting…","empty":"No results","previous":"Previous","next":"Next","page":"Page {{number}}","currency":"TND","Admin":"Admin","User":"User","EnAttente":"Pending","Acceptee":"Accepted","Rejetee":"Rejected","Annulee":"Cancelled"},
    "publisher": {"title":"Published by","role":"Advertiser","message":"Message","phone":"Phone","send":"Send","sending":"Sending…","sent":"Message sent."},
    "saveSearch": {"question":"Save this search?","save":"Save","saving":"Saving…","dismiss":"No thanks","saved":"Search saved in your recent searches.","error":"This search could not be saved."},
    "seo": {"categorySale":"Properties for sale in Tunisia","categoryRent":"Properties for rent in Tunisia","categoryAll":"Real estate listings in Tunisia","offers":"Real estate offers in Tunisia","vacation":"Holiday rentals in Tunisia","city":"Properties in {{city}}","searchCity":"Real estate listings in {{city}}","requests":"Property requests","request":"Looking for a property","listing":"Property listing","vacationListing":"Holiday rental","notFound":"Listing not found"},
    "mobile": {"search":"Search listings","notifications":"Notifications","filters":"Filters","closeFilters":"Close filters","popular":"Popular destinations","viewMap":"View on map","favorites":"My favorites","arrival":"Check-in","departure":"Check-out","language":"Language"},
    "mapZone": {
"bedrooms":"{{count}} bedroom(s)",
"perSquareMetre":"{{price}} TND/m²",
  "draw": "Draw a search area",
  "edit": "Edit area",
  "clear": "Clear area",
  "apply": "Apply area",
  "undo": "Remove last vertex",
  "cancel": "Cancel",
  "instructions": "Tap the map to add vertices. To move a vertex, tap it then tap its new position. Apply when finished.",
  "moveVertex": "Tap the new vertex position.",
  "invalid": "Draw a polygon with at least 3 vertices and no intersections.",
  "empty": "No loaded listings in this area.",
  "loaded": "Area search: {{count}} listing(s) among currently loaded results.",
  "all": "All loaded listings",
  "indicative": "Indicative 3D buildings: heights may be estimated by the map data source."
},
    "mapView": {
      "about": "About this map",
      "searchArea": "View {{count}} loaded properties in this area",
      "sameLocation": "At this location",
      "previous": "Previous property",
      "next": "Next property",
      "choose":"Choose a listing from the group",
      "display":"Results display","list":"List","map":"Map","loading":"Loading the map…",
      "count":"{{count}} properties displayed on the map","loadedOnly":"The map only shows results already loaded. Use “See more” to load further results.",
      "excluded":"{{count}} loaded listings have no usable location: view them in List mode.",
      "noCoordinates":"None of the loaded listings has a usable location.",
      "noProvider":"The map background is not configured. Locations remain available; you can also return to the list.",
      "tileError":"The map background is temporarily unavailable. Markers and List mode remain accessible.",
      "unavailable":"The map could not be loaded. Return to List mode to view the listings.",
      "cluster":"{{count}} listings: zoom in or expand the group","preview":"Listing preview","close":"Close preview",
      "noPrice":"View listing","price":"{{price}} TND","monthlyPrice":"{{price}} TND/month","nightlyPrice":"{{price}} TND/night"
    },
    "listingSort": {"label":"Sort by:","recent":"Most recent","price_asc":"Price: low to high","price_desc":"Price: high to low","price_m2_asc":"Price per m²: low to high","price_m2_desc":"Price per m²: high to low","surface_asc":"Area: low to high","surface_desc":"Area: high to low","bedrooms_asc":"Bedrooms: low to high","bedrooms_desc":"Bedrooms: high to low","night_price_asc":"Nightly price: low to high","night_price_desc":"Nightly price: high to low"},
    "vacationPrice": {"price":"Price","minimum":"Minimum price","maximum":"Maximum price","unit":"TND / night","apply":"Apply","from":"From","until":"Up to","invalid":"Enter non-negative prices, with the minimum less than or equal to the maximum."},
    "stay": {"weeklyDiscount":"Weekly discount","monthlyDiscount":"Monthly discount","estimatedTotal":"Estimated total","leaveDraft":"Leave this form and lose unsaved information?"},
    "publicEmail": {
      "title": "Contact",
      "intro": "A question about Lina Immo? Find our contact details below.",
      "home": "Home",
      "address": "Address",
      "city": "Kairouan, Tunisia",
      "telephone": "Phone",
      "whatsappHint": "Opens WhatsApp in a new tab",
      "formTitle": "Send us a message",
      "lastName": "Last name",
      "firstName": "First name",
      "email": "Email",
      "phone": "Phone (optional)",
      "message": "Message",
      "send": "Send",
      "sending": "Sending…",
      "required": "This field is required.",
      "invalidEmail": "Please enter a valid email address.",
      "contactSuccess": "Your message has been sent. Thank you for contacting us.",
      "sendError": "Sending could not be confirmed. Please try again later.",
      "notConfigured": "Sending is temporarily unavailable. Please try again later.",
      "newsletterTitle": "Stay informed with Lina Immo",
      "newsletterText": "Receive new listings, updates and news from Lina Immo directly by email.",
      "emailPlaceholder": "Your email address",
      "subscribe": "Subscribe",
      "newsletterSuccess": "Your newsletter subscription request has been sent. Thank you!"
},
    "my_profile": "My profile",
    "want_to_edit_name": "Want to edit your name?",
    "edit": "Edit",
    "apply_changes": "Save",
    "logout": "Sign out",
    "delete_account": "Delete my account",
    "delete_reason_placeholder": "Reason for deletion (optional)",
    "confirm_delete_account": "Delete permanently",
    "fill_reason_before_delete": "You can tell us why you are leaving.",
    "profile_updated": "Profile updated.",
    "profile_update_error": "Unable to update your profile.",
    "account_deleted": "Your account has been deleted.",
    "account_delete_error": "Unable to delete your account.",
    "write_message": "Write your message…",
    "Conversations": "Conversations",
    "piece": "rooms",
    "send": "Send",
    "show_conversations": "Show conversations",
    "hide_conversations": "Hide conversations",
    "amenities": {
      "wifi": "Wi-Fi",
      "workspace": "Dedicated workspace",
      "parking": "Free onsite parking",
      "piscine": "Private indoor pool",
      "tv": "TV",
      "camera": "Surveillance cameras",
      "barbecue": "Barbecue",
      "beachAccess": "Beach access",
      "ac": "Air conditioning"
    },
    "find_your_dream_property": "Find your dream property",
    "details_vacation": {
      "sending": "Sending...",
      "send_reservation": "Send request",
      "sending_in_progress": "Sending your reservation...",
      "reservation_sent": "Your booking request has been sent.",
      "contact_us": "Contact us",
      "our_cities": "Explore by city",
      "title": "Apartment Information",
      "guests": "{{count}} guest(s)",
      "bedrooms": "{{count}} bedroom(s) · {{beds}} bed(s)",
      "bathrooms": "bathroom(s)",
      "amenities": "Amenities",
      "arrival_date": "Check-in",
      "departure_date": "Check-out",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "message": "Message",
      "total_days": "Total days:",
      "total_price": "Estimated total",
      "discount_applied": "Discount",
      "per_night": "per night",
      "no_listings": "Currently, no listings available.",
      "follow_us": "Follow us",
      "newsletter": "Newsletter",
      "newsletter_text": "Get the latest listings and new property opportunities.",
      "your_email": "Your email",
      "subscribe": "Subscribe",
      "selectDay": "Select",
      "invalid_email": "Please enter a valid email address.",
      "login_required": "Please sign in to make a reservation.",
      "invalid_dates": "Select valid dates.",
      "email_error": "An error occurred while sending.",
      "reserve": "Book",
      "booking_request": "Booking request",
      "nights": "nights",
      "load_error": "Unable to load this rental.",
      "network_error": "A network error occurred.",
      "load_error_title": "Unable to load this rental",
      "no_amenities": "No amenities specified."
    },
    "profile": {
      "succes": "Deleted successfully",
      "echec": "Deletion failed",
      "user_not_connected": "You are not signed in.",
      "loading_error": "Unable to load your listings.",
      "confirm_delete": "Are you sure you want to delete this listing?",
      "delete_error": "An error occurred while deleting.",
      "my_space": "My property dashboard",
      "my_annonce": "My listings",
      "no_published_ads": "You have not published any listings yet.",
      "refresh": "Refresh",
      "empty_ads_description": "Publish your first property or holiday rental.",
      "vacation_ads": "Holiday rentals",
      "property_ads": "Properties",
      "logout_error": "Unable to sign out.",
      "name_required": "The name cannot be empty.",
      "no_changes": "No changes detected.",
      "final_delete_confirm": "This action is permanent. Are you sure you want to delete your account?",
      "recent_login_required": "For security, sign in again before deleting your account.",
      "description": "Manage your personal information and account settings.",
      "user": "User",
      "name": "Name",
      "email": "Email",
      "email_notice": "Your email address is linked to your sign-in account.",
      "saving": "Saving...",
      "session": "Session",
      "session_description": "You can sign out of your account at any time.",
      "danger_zone": "Danger zone",
      "delete_description": "Deleting your account is permanent and cannot be undone.",
      "delete_confirm_title": "Confirm deletion",
      "delete_reason_text": "You can tell us why you want to delete your account.",
      "deleting": "Deleting...",
      "ads": "listings",
      "ad": "listing",
      "published_ads": "published listings",
      "published_ad": "published listing"
    },
    "lord": "Travelers",
    "arrival": "Arrival",
    "destination": "Destination",
    "travelers": "Guests",
    "add_travelers": "Add travelers",
    "depart": "Check-out",
    "continue": "Continue",
    "previous": "Previous",
    "no_conversation": "No conversations",
    "entirePlace": "ENTIRE PLACE",
    "oneRoom": "ONE ROOM",
    "sharedRoom": "SHARED ROOM",
    "listing": {
      "alreadyContacted": "Already contacted",
      "alreadyContactedMessage": "You have already contacted this property’s owner.",
      "noData": "This listing could not be found.",
      "contactLandlord": "Contact the advertiser",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "addMessage": "Message",
      "description": "Description",
      "shareLinkCopied": "Link copied",
      "rent": "For rent",
      "sale": "For sale",
      "bedroom": " Bedroom",
      "bedrooms": "Bedrooms",
      "bathroom": " Bathroom",
      "parking": "Parking",
      "noParking": "No parking",
      "furnished": "Furnished",
      "notFurnished": "Unfurnished",
      "showNumber": "Show number",
      "message": "Hello, I’m interested in your property, is it still available?",
      "available": "Available",
      "month": "month",
      "untitled": "Property listing",
      "locationUnavailable": "Location not specified",
      "bedroomsShort": "beds",
      "bathroomsShort": "Baths",
      "surface": "Area",
      "viewLand": "View land",
      "viewDetails": "View accommodation",
      "new": "New",
      "bathrooms": "Baths",
      "loadingError": "Unable to load this listing.",
      "completeFields": "Please complete all fields.",
      "networkError": "A network error occurred.",
      "loadingTitle": "Unable to load the listing",
      "property": "Property listing",
      "youSave": "Save",
      "noDescription": "No description available.",
      "location": "Location",
      "openMaps": "Open in Maps",
      "contactDescription": "Get more information or arrange a viewing of this property.",
      "messageSent": "Your message has been sent.",
      "sendMessage": "Send a message",
      "namePlaceholder": "Your name",
      "send": "Send message",
      "ownerNotice": "You own this listing."
    },
    "create_ad": "Post an ad",
    "No_ads": "There are no listings available currently",
    "No_request": "No requests yet",
    "No_reserved": "No bookings yet",
    "ads": "Listings",
    "create_adW": "List a holiday rental",
    "update_ad": "Update rental",
    "sell / rent": "Sale or rental",
    "sell": "Sell",
    "rent": "Rent",
    "choose_property_type": "Property type",
    "apartment": "Apartment",
    "house": "House",
    "commercial": "Commercial",
    "land": "Land",
    "others": "Other",
    "label": "Listing title",
    "description": "Description",
    "surface": "Area",
    "price": "Price per night",
    "city": "All cities",
    "delegation": "All districts",
    "offer": "Special offer",
    "yes": "Yes",
    "no": "No",
    "address": "Address",
    "postal_code": "Postal code",
    "bathrooms": "Baths",
    "bathroom": "Bathroom",
    "beds": "beds",
    "bedrooms": "bedrooms",
    "parking": "Parking",
    "furnished": "Furnished",
    "add_image": "Add an image",
    "add_ad": "Post an ad",
    "add_ad_short": "Post an ad",
    "choose_file": "Choose a file",
    "no_file_selected": "No file selected",
    "create_ad_button": "Create Listing",
    "Kairouan": "Kairouan",
    "home": "Home",
    "buy": "Buy",
    "offers": "Offers",
    "recent_offers": "Recent offers",
    "Contacts": "Your contact details",
    "SoldeW": "Weekly discount",
    "SoldeW_": "For a one-week stay",
    "SoldeM": "Monthly discount",
    "SoldeM_": "For a one-month stay",
    "see_all_offers": "See all our offers",
    "see_plus": "Show more",
    "no_exact_match": "No rentals found",
    "modify_filters": "Change your destination or number of guests to find more accommodation.",
    "for_rent": "For Rent",
    "see_all_ads": "See all ads",
    "for_sale": "For Sale",
    "fetch_fail": "Failed to fetch data",
    "fetch_error": "An error occurred:",
    "my_favorites": "My favorites",
    "recent_searches": "Recent searches",
    "recently_viewed": "Recently viewed",
    "my_annonce": "My listings",
    "my_reservation": "My bookings",
    "my_message": "Messages",
    "my_profil": "My profile",
    "my_demande": "Booking requests",
    "my_alerts": "My alerts",
    "SelectCity": "Select a city",
    "numtel": "Phone",
    "email": "Email",
    "vacances": "Vacation rentals",
    "guesthouse": "Guesthouse",
    "partyrooms": "Party rooms",
    "upload": "Upload images or click the button",
    "guestNumbers": "Number of people",
    "month": "Month",
    "sign_in": "Sign In",
    "location_day": "Rental per day",
    "email_placeholder": "Email address",
    "location_Vacation": "Find your vacation rental",
    "password_placeholder": "Password",
    "incorrect_email_password": "Incorrect email and/or password",
    "no_account": "Don't have an account?",
    "sign_up": "Sign up",
    "forgot_password": "Forgot password?",
    "or": "OR",
    "confirmation_password": "Confirm password",
    "reset_password": "Reset Password",
    "email_sent": "The email has been sent",
    "reset_password_error": "Unable to send reset password email",
    "message": "Message",
    "call": "Call",
    "title": "Accommodation",
    "contact": "Contact",
    "request_date": "Request",
    "start": "Check-in",
    "end": "Check-out",
    "status": "Status",
    "actions": "Actions",
    "validate": "Accept",
    "cancel": "Cancel",
    "pending": "Pending",
    "confirmed": "Confirmed",
    "rejected": "Rejected",
    "canceled": "Canceled",
    "expired": "Expired",
    "request_list": "Booking requests",
    "list_title": "My bookings",
    "no_title": "No reservation found",
    "no_requests": "No requests found",
    "error": "Error",
    "cancel_confirm": "Are you sure you want to reject this request?",
    "cancel_success": "Request has been canceled",
    "accept_success": "Request accepted",
    "ui": {
      "page_not_found": "Page not found.",
      "home": "Home",
      "you_are_not_signed_in": "You are not signed in.",
      "unable_to_load_your_listings": "Unable to load your listings.",
      "are_you_sure_you_want_to_delete_this_listing": "Are you sure you want to delete this listing?",
      "deletion_failed": "Deletion failed.",
      "listing_deleted_successfully": "Listing deleted successfully.",
      "an_error_occurred_while_deleting": "An error occurred while deleting.",
      "my_property_dashboard": "My property dashboard",
      "my_listings": "My listings",
      "you_have_not_published_any_listings_yet": "You have not published any listings yet.",
      "refresh": "Refresh",
      "add_a_listing": "Add a listing",
      "no_listings_available": "No listings available",
      "publish_your_first_property_or_holiday_rental": "Publish your first property or holiday rental.",
      "list_a_property": "List a property",
      "list_a_holiday_rental": "List a holiday rental",
      "holiday_rentals": "Holiday rentals",
      "properties": "Properties",
      "what_this_accommodation_offers": "What this accommodation offers",
      "lina_immo_property_listing": "Lina Immo property listing",
      "for_rent": "For rent",
      "for_sale": "For sale",
      "available": "Available",
      "photos": "photos",
      "month": "month",
      "property_listing": "Property listing",
      "location_not_specified": "Location not specified",
      "beds": "Beds",
      "baths": "Baths",
      "area": "Area",
      "yes": "Yes",
      "no": "No",
      "parking": "Parking",
      "edit": "Edit",
      "delete": "Delete",
      "view_details": "View details",
      "unable_to_retrieve_the_data": "Unable to retrieve the data.",
      "contact": "Contact",
      "contact_details": "Contact details",
      "email": "Email",
      "phone": "Phone",
      "WhatsApp": "WhatsApp",
      "profile": "Profile",
      "user": "User",
      "email_unavailable": "Email unavailable",
      "phone_number_not_provided": "Phone number not provided",
      "select_a_conversation": "Select a conversation.",
      "conversations": "Conversations",
      "search_conversations": "Search conversations",
      "listing_deleted": "Listing deleted",
      "about_this_listing": "About this listing",
      "view_messages": "View messages",
      "delete_conversation": "Delete conversation",
      "no_conversations_found": "No conversations found",
      "all_your_conversations_in_one_place": "All your conversations in one place.",
      "please_enter_an_address": "Please enter an address.",
      "address_not_found": "Address not found.",
      "unable_to_search_for_this_address_right_now": "Unable to search for this address right now.",
      "please_enter_the_address_city_and_delegation": "Please enter the address, city and delegation.",
      "address": "Address",
      "enter_an_address": "Enter an address",
      "search_address": "Search address",
      "city": "City",
      "select_a_city": "Select a city",
      "postal_code": "Postal code",
      "delegation": "Delegation",
      "select_a_delegation": "Select a delegation",
      "map_preview": "Map preview",
      "previous": "Previous",
      "continue": "Continue",
      "describe_your_property": "Describe your property!",
      "bedrooms": "Bedrooms",
      "bathrooms": "Bathrooms",
      "upload_images_of_your_property": "Upload images of your property",
      "unable_to_share_the_link_please_try_again": "Unable to share the link. Please try again.",
      "about_us": "About us",
      "terms_of_use": "Terms of use",
      "privacy_policy": "Privacy policy",
      "back_to_home": "Back to home",
      "rent_invest_negotiate_buy": "Rent · Invest · Negotiate · Buy",
      "find_your_next_home_list_your_property_and_discover_real_estate_opportunities_across_tunisia": "Find your next home, list your property and discover real estate opportunities across Tunisia.",
      "navigation": "Navigation",
      "explore_by_city": "Explore by city",
      "discover_available_properties_in_the_most_popular_cities": "Discover available properties in the most popular cities.",
      "show_less": "Show less",
      "view_all_cities": "View all cities",
      "keep_in_touch": "Keep in touch",
      "email_94": "Email",
      "kairouan_tunisia": "Kairouan, Tunisia",
      "paris_france": "Paris, France",
      "newsletter": "Newsletter",
      "get_the_latest_listings_and_new_property_opportunities": "Get the latest listings and new property opportunities.",
      "your_email": "Your email",
      "subscribe_to_the_newsletter": "Subscribe to the newsletter",
      "sign_up": "Sign up",
      "lina_immo_all_rights_reserved": "Lina Immo. All rights reserved.",
      "privacy": "Privacy",
      "terms": "Terms",
      "back_to_top": "Back to top",
      "menu": "Menu",
      "close_menu": "Close menu",
      "sale_or_long_term_rental": "Sale or long-term rental",
      "daily_or_holiday_rental": "Daily or holiday rental",
      "open_menu": "Open menu",
      "close_mobile_menu": "Close mobile menu",
      "lina_immo_home": "Lina Immo — Home",
      "real_estate_made_simple": "Real estate, made simple.",
      "main_navigation": "Main navigation",
      "mobile_menu": "Mobile menu",
      "mobile_navigation": "Mobile navigation",
      "preview": "Preview",
      "you_can_upload_up_to_6_images": "You can upload up to 6 images.",
      "some_files_exceed_the_5_mb_limit_and_will_not_be_added": "Some files exceed the 5 MB limit and will not be added.",
      "step_6": "Step 6",
      "add_photos_of_your_property": "Add photos of your property",
      "add_bright_high_quality_photos_to_make_your_listing_more_appealing": "Add bright, high-quality photos to make your listing more appealing.",
      "upload_photos": "Upload photos",
      "choose_a_main_photo_then_add_the_rooms_and_amenities": "Choose a main photo, then add the rooms and amenities.",
      "tips": "Tips",
      "use_clear_bright_landscape_photos_avoid_blurry_or_dark_images": "Use clear, bright landscape photos. Avoid blurry or dark images.",
      "choose_a_language": "Choose a language",
      "language": "Language",
      "view_listing": "View listing",
      "rent": "Rent",
      "sale": "Sale",
      "new": "New",
      "beds_140": "beds",
      "listing_displayed_on_the_home_page": "Listing displayed on the home page",
      "no_images_available": "No images available",
      "host": "Host:",
      "tnd_night": "TND / night",
      "please_enter_a_valid_email_address": "Please enter a valid email address.",
      "please_sign_in_to_make_a_reservation": "Please sign in to make a reservation.",
      "select_valid_dates": "Select valid dates.",
      "your_booking_request_has_been_sent": "Your booking request has been sent.",
      "an_error_occurred_while_sending": "An error occurred while sending.",
      "holiday_rental": "Holiday rental",
      "holidays": "Holidays",
      "night": "night",
      "guests": "guests",
      "bedrooms_154": "bedrooms",
      "book": "Book",
      "call": "Call",
      "view_accommodation": "View accommodation",
      "lina_immo_holidays": "Lina Immo Holidays",
      "booking_request": "Booking request",
      "close": "Close",
      "night_161": "/ night",
      "check_in_date": "Check-in date",
      "select": "Select",
      "check_out_date": "Check-out date",
      "guests_165": "Guests",
      "name": "Name",
      "message": "Message",
      "the_length_of_stay_discount_must_be_confirmed_before_booking": "The length-of-stay discount must be confirmed before booking.",
      "tnd": "TND ×",
      "nights": "nights",
      "discount_applied": "Discount applied",
      "estimated_total": "Estimated total",
      "sending": "Sending...",
      "send_request": "Send request",
      "locate_your_property": "Locate your property",
      "cost": "Cost",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "contact_details_179": "Contact details",
      "property_location": "Property location",
      "find_this_address": "Find this address",
      "postal_code_182": "Postal code",
      "select_a_city_183": "Select a city",
      "select_a_district": "Select a district",
      "view_conversations": "View conversations",
      "your_conversation_starts_here": "Your conversation starts here",
      "ask_your_first_question_about_this_listing": "Ask your first question about this listing.",
      "this_listing_has_been_deleted_you_can_still_read_your_messages": "This listing has been deleted. You can still read your messages.",
      "this_recipient_is_no_longer_available_you_can_still_read_your_messages": "This recipient is no longer available. You can still read your messages.",
      "your_message": "Your message",
      "write_your_message": "Write your message…",
      "send": "Send",
      "enter_to_send_shift_enter_for_a_new_line": "Enter to send · Shift + Enter for a new line",
      "signed_in_with_google": "Signed in with Google!",
      "unable_to_sign_in_with_google": "Unable to sign in with Google.",
      "continue_with_google": "Continue with Google",
      "signing_in_with_google": "Signing in…",
      "google_popup_blocked": "The Google window was blocked. Allow pop-ups and try again.",
      "google_network_error": "No Internet connection. Please try again.",
      "price": "Price",
      "discounted_price": "Discounted price",
      "download_the_pdf_to_print": "Download the PDF to print",
      "describe_your_property_202": "Describe your property",
      "title": "Title",
      "description": "Description",
      "area_m": "Area (m²)",
      "number_of_bedrooms": "Number of bedrooms",
      "number_of_bathrooms": "Number of bathrooms",
      "furnished": "Furnished",
      "tnd_209": "TND /",
      "total_price": "Total price:",
      "host_211": "Host:",
      "rating": "Rating:",
      "reviews": "reviews)",
      "in_dinars": "in dinars",
      "loading": "Loading...",
      "no_properties_available": "No properties available",
      "month_217": "/ month",
      "loading_218": "Loading…",
      "no_vacation_rentals_available_at_the_moment": "No vacation rentals available at the moment.",
      "loading_220": "Loading...",
      "user_account": "User account",
      "my_account": "My account",
      "sign_in": "Sign in",
      "create_an_account": "Create an account",
      "offer": "Offer",
      "sign_in_to_use_favorites": "Sign in to use favorites.",
      "refresh_your_favorites_before_trying_again": "Refresh your favorites before trying again.",
      "unable_to_load_requests": "Unable to load requests.",
      "expired": "Expired",
      "pending": "Pending",
      "confirmed": "Confirmed",
      "rejected": "Rejected",
      "cancelled": "Cancelled",
      "invalid_request_id": "Invalid request ID.",
      "unable_to_update_the_request": "Unable to update the request.",
      "request_accepted": "Request accepted.",
      "are_you_sure_you_want_to_reject_this_request": "Are you sure you want to reject this request?",
      "request_rejected": "Request rejected.",
      "booking_requests": "Booking requests",
      "view_incoming_requests_and_accept_or_reject_bookings": "View incoming requests and accept or reject bookings.",
      "confirmed_242": "Confirmed",
      "rejected_243": "Rejected",
      "expired_244": "Expired",
      "error": "Error",
      "accommodation": "Accommodation",
      "request_date": "Request date",
      "check_in": "Check-in",
      "check_out": "Check-out",
      "accept": "Accept",
      "reject": "Reject",
      "request": "Request",
      "status": "Status",
      "actions": "Actions",
      "no_requests": "No requests",
      "you_have_no_booking_requests_to_review_at_the_moment": "You have no booking requests to review at the moment.",
      "unable_to_load_your_bookings": "Unable to load your bookings.",
      "are_you_sure_you_want_to_cancel_this_booking": "Are you sure you want to cancel this booking?",
      "booking_cancelled": "Booking cancelled.",
      "unable_to_cancel_the_booking": "Unable to cancel the booking.",
      "my_bookings": "My bookings",
      "view_and_manage_all_your_booking_requests": "View and manage all your booking requests.",
      "cancelled_263": "Cancelled",
      "booking": "Booking",
      "cancel": "Cancel",
      "no_bookings": "No bookings",
      "you_have_no_bookings_to_display_at_the_moment": "You have no bookings to display at the moment.",
      "error_268": "Error:",
      "text_search": "Text search:",
      "listings_found": "Listings found",
      "continue_to_the_next_listings": "Continue to the next listings",
      "offers_found_in": "Offers found in",
      "hide_conversations": "Hide conversations",
      "show_conversations": "Show conversations",
      "no_conversations": "No conversations",
      "listing": "Listing",
      "write_your_message_277": "Write your message...",
      "select_a_conversation_to_get_started": "Select a conversation to get started.",
      "unable_to_load_your_conversations": "Unable to load your conversations.",
      "unable_to_load_this_conversation": "Unable to load this conversation.",
      "unable_to_send_the_message": "Unable to send the message.",
      "do_you_want_to_delete_this_conversation": "Do you want to delete this conversation?",
      "unable_to_delete_this_conversation": "Unable to delete this conversation.",
      "sign_in_required": "Sign-in required",
      "sign_in_to_view_your_conversations": "Sign in to view your conversations.",
      "your_conversations_with_owners_and_users_will_appear_here": "Your conversations with owners and users will appear here.",
      "select_a_conversation_287": "Select a conversation",
      "choose_a_conversation_to_view_its_messages": "Choose a conversation to view its messages.",
      "type": "Type",
      "photos_290": "Photos",
      "select_the_transaction_and_property_type": "Select the transaction and property type.",
      "a_listing_title_is_required": "A listing title is required.",
      "enter_a_valid_area": "Enter a valid area.",
      "enter_the_property_address": "Enter the property address.",
      "enter_a_valid_price": "Enter a valid price.",
      "the_discounted_price_must_be_below_the_original_price": "The discounted price must be below the original price.",
      "enter_your_email_and_phone_number": "Enter your email and phone number.",
      "you_must_be_signed_in_to_post_a_listing": "You must be signed in to post a listing.",
      "add_at_least_one_photo": "Add at least one photo.",
      "your_listing_has_been_published_successfully": "Your listing has been published successfully.",
      "unable_to_publish_the_listing": "Unable to publish the listing.",
      "enter_your_property_details_in_a_few_steps": "Enter your property details in a few steps.",
      "what_type_of_listing_would_you_like_to_post": "What type of listing would you like to post?",
      "choose_the_transaction_and_property_type": "Choose the transaction and property type.",
      "sale_or_rental": "Sale or rental",
      "sell": "Sell",
      "rent_308": "Rent",
      "property_type": "Property type",
      "add_a_clear_title_and_the_main_features": "Add a clear title and the main features.",
      "listing_title": "Listing title",
      "e_g_bright_apartment_in_tunis": "E.g. Bright apartment in Tunis",
      "describe_the_highlights_of_your_property": "Describe the highlights of your property...",
      "enter_the_exact_address_so_buyers_can_easily_locate_your_property": "Enter the exact address so buyers can easily locate your property.",
      "set_the_price": "Set the price",
      "enter_the_property_price_and_optionally_add_a_discount": "Enter the property price and optionally add a discount.",
      "special_offer": "Special offer",
      "discounted_price_318": "Discounted price",
      "your_contact_details": "Your contact details",
      "these_details_will_allow_interested_people_to_contact_you": "These details will allow interested people to contact you.",
      "add_your_photos": "Add your photos",
      "add_bright_clear_photos_to_showcase_your_property": "Add bright, clear photos to showcase your property.",
      "publishing": "Publishing...",
      "publish_listing": "Publish listing",
      "address_not_found_325": "Address not found",
      "listing_published": "Listing published.",
      "amenities": "Amenities",
      "capacity": "Capacity",
      "rates": "Rates",
      "select_an_accommodation_type": "Select an accommodation type.",
      "the_accommodation_must_host_at_least_one_person": "The accommodation must host at least one person.",
      "enter_a_valid_price_332": "Enter a valid price.",
      "the_discounted_price_must_be_below_the_regular_price": "The discounted price must be below the regular price.",
      "enter_your_email_and_phone_number_334": "Enter your email and phone number.",
      "your_vacation_rental_has_been_published": "Your vacation rental has been published.",
      "unable_to_publish_your_listing": "Unable to publish your listing.",
      "present_your_accommodation_amenities_and_rates_in_a_few_steps": "Present your accommodation, amenities and rates in a few steps.",
      "what_type_of_accommodation_do_you_offer": "What type of accommodation do you offer?",
      "select_the_option_that_matches_your_rental": "Select the option that matches your rental.",
      "amenities_and_services": "Amenities and services",
      "select_the_amenities_available_in_your_accommodation": "Select the amenities available in your accommodation.",
      "locate_the_accommodation": "Locate the accommodation",
      "enter_the_address_and_check_the_location_on_the_map": "Enter the address and check the location on the map.",
      "accommodation_capacity": "Accommodation capacity",
      "enter_the_number_of_guests_bedrooms_beds_and_bathrooms": "Enter the number of guests, bedrooms, beds and bathrooms.",
      "set_your_rates": "Set your rates",
      "enter_the_daily_rate_and_any_discounts": "Enter the daily rate and any discounts.",
      "price_per_night": "Price per night",
      "weekly_discount": "Weekly discount",
      "for_a_one_week_stay": "For a one-week stay",
      "monthly_discount": "Monthly discount",
      "for_a_one_month_stay": "For a one-month stay",
      "these_details_will_allow_guests_to_contact_you": "These details will allow guests to contact you.",
      "add_accommodation_photos": "Add accommodation photos",
      "choose_bright_photos_that_show_the_rooms_and_amenities": "Choose bright photos that show the rooms and amenities.",
      "publish_rental": "Publish rental",
      "wi_fi": "Wi-Fi",
      "dedicated_workspace": "Dedicated workspace",
      "free_on_site_parking": "Free on-site parking",
      "private_indoor_pool": "Private indoor pool",
      "tv": "TV",
      "security_cameras": "Security cameras",
      "barbecue": "Barbecue",
      "beach_access": "Beach access",
      "air_conditioning": "Air conditioning",
      "check_in_cannot_be_after_check_out": "Check-in cannot be after check-out.",
      "sign_in_to_send_a_booking_request": "Sign in to send a booking request.",
      "your_message_has_been_sent_successfully": "Your message has been sent successfully.",
      "error_369": "Error:",
      "apartment_information": "Apartment information",
      "guest_s": "guest(s)",
      "bedroom_s": "bedroom(s) ·",
      "bed_s": "bed(s)",
      "bathroom_s": "bathroom(s)",
      "phone_number": "Phone number:",
      "event_form": "Event form",
      "title_377": "Title *",
      "first_name": "First name *",
      "last_name": "Last name *",
      "event_type": "Event type",
      "one_hour_marriage_ceremony": "One-hour marriage ceremony",
      "birthday": "Birthday",
      "other": "Other",
      "mobile_phone": "Mobile phone *",
      "email_385": "Email *",
      "event_date": "Event date *",
      "start_time": "Start time",
      "end_time": "End time",
      "number_of_guests": "Number of guests *",
      "unable_to_load_this_rental": "Unable to load this rental.",
      "a_network_error_occurred": "A network error occurred.",
      "unable_to_load_this_rental_392": "Unable to load this rental",
      "this_rental_could_not_be_found": "This rental could not be found.",
      "vacation_rental": "Vacation rental",
      "tnd_395": "TND /",
      "beds_396": "beds",
      "no_amenities_specified": "No amenities specified.",
      "per_night": "per night",
      "discount": "Discount",
      "guest_s_400": "guest(s) ·",
      "bed_s_401": "bed(s) ·",
      "1_guest": "1 guest",
      "2_guests": "2 guests",
      "3_guests": "3 guests",
      "4_guests": "4 guests",
      "5_guests": "5 guests",
      "6_guests": "6 guests",
      "7_guests": "7 guests",
      "8_guests": "8 guests",
      "tnd_410": "TND ×",
      "weekly_discount_411": "Weekly discount",
      "tnd_412": "TND)",
      "monthly_discount_413": "Monthly discount",
      "tnd_414": "TND)",
      "total": "Total",
      "by_email": "By email:",
      "or": "OR",
      "call_418": "Call:",
      "property": "Property",
      "information": "Information",
      "invalid_listing_id": "Invalid listing ID.",
      "you_do_not_own_this_listing": "You do not own this listing.",
      "this_listing_could_not_be_found": "This listing could not be found.",
      "unable_to_retrieve_this_listing_s_information": "Unable to retrieve this listing's information.",
      "no_changes_detected": "No changes detected.",
      "the_listing_has_been_updated": "The listing has been updated.",
      "unable_to_update_the_listing": "Unable to update the listing.",
      "unable_to_edit_the_listing": "Unable to edit the listing",
      "back_to_my_listings": "Back to my listings",
      "edit_listing": "Edit listing",
      "edit_your_listing_details_then_save_your_changes": "Edit your listing details, then save your changes.",
      "unsaved_changes": "Unsaved changes",
      "step_1": "Step 1",
      "property_information": "Property information",
      "edit_the_main_details_of_your_listing": "Edit the main details of your listing.",
      "step_2": "Step 2",
      "additional_information": "Additional information",
      "complete_the_property_s_features_and_additional_details": "Complete the property's features and additional details.",
      "step_3": "Step 3",
      "listing_photos": "Listing photos",
      "keep_remove_or_add_photos_to_your_listing": "Keep, remove or add photos to your listing.",
      "manage_photos": "Manage photos",
      "existing_photos_are_kept_unless_you_delete_them_you_can_also_add_new_ones": "Existing photos are kept unless you delete them. You can also add new ones.",
      "updating": "Updating...",
      "update_listing": "Update listing",
      "bathrooms_446": "Bathrooms",
      "unable_to_retrieve_this_rental_s_information": "Unable to retrieve this rental's information.",
      "the_rental_has_been_updated": "The rental has been updated.",
      "unable_to_update_the_rental": "Unable to update the rental.",
      "unable_to_edit_this_rental": "Unable to edit this rental",
      "edit_rental": "Edit rental",
      "edit_your_accommodation_amenities_details_and_photos": "Edit your accommodation, amenities, details and photos.",
      "accommodation_information": "Accommodation information",
      "edit_the_main_details_of_your_vacation_rental": "Edit the main details of your vacation rental.",
      "edit_the_accommodation_s_capacity_rates_and_additional_details": "Edit the accommodation's capacity, rates and additional details.",
      "specify_the_amenities_available_to_guests": "Specify the amenities available to guests.",
      "accommodation_photos": "Accommodation photos",
      "keep_remove_or_add_photos_to_your_rental": "Keep, remove or add photos to your rental.",
      "keep_your_existing_photos_or_add_new_ones_to_showcase_your_accommodation": "Keep your existing photos or add new ones to showcase your accommodation.",
      "update_rental": "Update rental",
      "my_activity": "My activity",
      "sign_in_to_view_your_activity": "Sign in to view your activity.",
      "nothing_here_yet": "Nothing here yet.",
      "clear_history": "Clear history",
      "search_again": "— Search again",
      "buy": "Buy",
      "houses_apartments": "Houses & apartments",
      "apartments_houses": "Apartments & houses",
      "villas_residences": "Villas & residences",
      "offices": "Offices",
      "business_spaces": "Business spaces",
      "shops": "Shops",
      "premises_businesses": "Premises & businesses",
      "land": "Land",
      "land_for_sale": "Land for sale",
      "available_properties": "Available properties",
      "satisfied_customers": "Satisfied customers",
      "governorates_covered": "Governorates covered",
      "average_rating": "Average rating",
      "verified_listings": "Verified listings",
      "all_listings_are_manually_reviewed": "All listings are manually reviewed.",
      "secure_payment": "Secure payment",
      "your_transactions_are_protected_and_secure": "Your transactions are protected and secure.",
      "support_7_days_a_week": "Support 7 days a week",
      "our_team_is_available_to_help_you": "Our team is available to help you.",
      "certified_agents": "Certified agents",
      "real_estate_professionals_at_your_service": "Real estate professionals at your service.",
      "i_found_my_apartment_in_just_two_days_fast_and_efficient_service": "I found my apartment in just two days. Fast and efficient service!",
      "the_site_is_very_easy_to_use_and_the_listings_are_high_quality": "The site is very easy to use and the listings are high quality.",
      "thanks_to_the_lina_immo_team_for_their_professionalism_and_attentiveness": "Thanks to the Lina Immo team for their professionalism and attentiveness.",
      "unable_to_load_listings": "Unable to load listings.",
      "houses_for_sale_rentals_and_villas_in_tunisia_lina_immo": "Houses for sale, rentals and villas in Tunisia — Lina Immo",
      "explore_lina_immo_listings_houses_for_sale_apartments_for_rent_villas_land_and_vacation_rentals_in_t": "Explore Lina Immo listings: houses for sale, apartments for rent, villas, land and vacation rentals in Tunisia.",
      "tunisia_real_estate_house_for_sale_apartment_for_rent_villa_for_sale_land_vacation_rental_tunis_sfax": "Tunisia real estate, house for sale, apartment for rent, villa for sale, land, vacation rental, Tunis, Sfax, Sousse, Hammamet",
      "your_real_estate_partner_in_tunisia": "Your real estate partner in Tunisia",
      "find_your_next_home": "Find your next home",
      "buy_rent_or_book_the_property_that_meets_your_needs_anywhere_in_tunisia": "Buy, rent or book the property that meets your needs anywhere in Tunisia.",
      "governorate": "Governorate",
      "all_governorates": "All governorates",
      "all_districts": "All districts",
      "all_types": "All types",
      "apartment": "Apartment",
      "house": "House",
      "villa": "Villa",
      "office": "Office",
      "shop": "Shop",
      "land_508": "Land",
      "maximum_price": "Maximum price",
      "all_budgets": "All budgets",
      "searching": "Searching...",
      "search": "Search",
      "over_12_000_listings_available": "Over 12,000 listings available",
      "explore_by_category": "Explore by category",
      "why_choose_lina_immo": "Why choose Lina Immo?",
      "our_popular_cities": "Our popular cities",
      "they_trust_us": "They trust us",
      "mobile_app": "Mobile app",
      "take_lina_immo_everywhere": "Take Lina Immo everywhere",
      "find_your_favorite_listings_contact_owners_and_post_properties_from_your_phone": "Find your favorite listings, contact owners and post properties from your phone.",
      "available_on_google_play": "▶ Available on Google Play",
      "android_pending_validation": "Awaiting test approval on Google Play.",
      "ios_coming_soon": "Coming soon.",
      "download_on_the_app_store": " Download on the App Store",
      "stay_informed": "Stay informed",
      "receive_new_listings_and_real_estate_offers_directly_by_email": "Receive new listings and real estate offers directly by email.",
      "your_email_address": "Your email address",
      "unable_to_load_this_listing": "Unable to load this listing.",
      "please_complete_all_fields": "Please complete all fields.",
      "unable_to_load_the_listing": "Unable to load the listing",
      "link_copied": "Link copied",
      "special_offer_530": "Special offer",
      "save": "Save",
      "no_parking": "No parking",
      "unfurnished": "Unfurnished",
      "no_description_available": "No description available.",
      "location": "Location",
      "open_in_maps": "Open in Maps",
      "contact_the_owner": "Contact the advertiser",
      "get_more_information_or_arrange_a_viewing_of_this_property": "Get more information or arrange a viewing of this property.",
      "your_message_has_been_sent": "Your message has been sent.",
      "send_a_message": "Send a message",
      "your_name": "Your name",
      "send_message": "Send message",
      "you_own_this_listing": "You own this listing.",
      "no_photos_available": "No photos available",
      "view": "View",
      "share_listing": "Share listing",
      "photo_gallery": "Photo gallery",
      "close_gallery": "Close gallery",
      "empty_message": "[Empty message]",
      "offers_found": "Offers found",
      "no_exact_matches": "No exact matches",
      "change_or_remove_some_filters_or_adjust_your_search_area": "Change or remove some filters or adjust your search area.",
      "date": "Date",
      "unable_to_sign_out": "Unable to sign out.",
      "the_name_cannot_be_empty": "The name cannot be empty.",
      "profile_updated": "Profile updated.",
      "unable_to_update_your_profile": "Unable to update your profile.",
      "you_can_tell_us_why_you_are_leaving": "You can tell us why you are leaving.",
      "this_action_is_permanent_are_you_sure_you_want_to_delete_your_account": "This action is permanent. Are you sure you want to delete your account?",
      "your_account_has_been_deleted": "Your account has been deleted.",
      "for_security_sign_in_again_before_deleting_your_account": "For security, sign in again before deleting your account.",
      "unable_to_delete_your_account": "Unable to delete your account.",
      "my_profile": "My profile",
      "manage_your_personal_information_and_account_settings": "Manage your personal information and account settings.",
      "your_email_address_is_linked_to_your_sign_in_account": "Your email address is linked to your sign-in account.",
      "save_567": "Save",
      "session": "Session",
      "you_can_sign_out_of_your_account_at_any_time": "You can sign out of your account at any time.",
      "sign_out": "Sign out",
      "danger_zone": "Danger zone",
      "deleting_your_account_is_permanent_and_cannot_be_undone": "Deleting your account is permanent and cannot be undone.",
      "delete_my_account": "Delete my account",
      "confirm_deletion": "Confirm deletion",
      "you_can_tell_us_why_you_want_to_delete_your_account": "You can tell us why you want to delete your account.",
      "reason_for_deletion_optional": "Reason for deletion (optional)",
      "deleting": "Deleting...",
      "delete_permanently": "Delete permanently",
      "cancel_this_booking_request": "Cancel this booking request?",
      "my_booking": "My booking",
      "loading_581": "Loading…",
      "no_bookings_available": "No bookings available.",
      "guests_583": "guests ·",
      "accepted": "Accepted",
      "rejected_585": "Rejected",
      "unknown_status": "Unknown status",
      "listing_deleted_587": "Listing deleted",
      "cancel_request": "Cancel request",
      "studio": "Studio",
      "2_rooms": "2 rooms",
      "3_rooms": "3 rooms",
      "4_rooms": "4 rooms",
      "5_rooms": "5 rooms",
      "6_or_more_rooms": "6 or more rooms",
      "property_search": "Property search",
      "select_a_city_then_refine_your_search_criteria": "Select a city, then refine your search criteria.",
      "all_cities": "View all cities",
      "category": "Category",
      "all_categories": "View all categories",
      "commercial": "Commercial",
      "other_601": "Other",
      "hide_filters": "Hide filters",
      "advanced_search": "Advanced search",
      "keyword": "Keyword",
      "apartment_villa_land": "Apartment, villa, land...",
      "number_of_rooms": "Number of rooms",
      "minimum_price": "Minimum price",
      "reset": "Reset",
      "at_least_6_characters": "At least 6 characters",
      "passwords_do_not_match": "Passwords do not match",
      "a_verification_email_has_been_sent_please_verify_your_email_before_continuing": "A verification email has been sent. Please verify your email before continuing.",
      "email_verified": "Email verified!",
      "invalid_email": "Invalid email",
      "email_already_in_use": "Email already in use",
      "registration_failed": "Registration failed",
      "illustration": "Illustration",
      "unable_to_load_vacation_rentals": "Unable to load vacation rentals.",
      "find_your_vacation_rental": "Find your vacation rental",
      "discover_accommodation_across_tunisia_for_your_holidays_and_short_stays": "Discover accommodation across Tunisia for your holidays and short stays.",
      "title_or_location": "Title or location",
      "destination": "Destination",
      "number": "Number",
      "available_stays": "Available stays",
      "rentals_in_city": "Rentals in {{city}}",
      "all_rentals": "View all rentals",
      "show_more": "Show more",
      "no_rentals_found": "No rentals found",
      "change_your_destination_or_number_of_guests_to_find_more_accommodation": "Change your destination or number of guests to find more accommodation.",
      "reset_filters": "Reset filters",
      "sign_in_to_continue": "Sign in to continue.",
      "your_session_has_changed_sign_in_again": "Your session has changed. Sign in again.",
      "invalid_request_check_the_information_entered": "Invalid request. Check the information entered.",
      "your_session_is_invalid_or_expired_sign_in_again": "Your session is invalid or expired. Sign in again.",
      "you_are_not_allowed_to_perform_this_action": "You are not allowed to perform this action.",
      "this_resource_could_not_be_found_or_has_been_deleted": "This resource could not be found or has been deleted.",
      "this_action_conflicts_with_the_current_data_refresh_and_try_again": "This action conflicts with the current data. Refresh and try again.",
      "this_listing_has_been_deleted": "This listing has been deleted.",
      "api_url_not_allowed": "API URL not allowed.",
      "unable_to_connect_check_your_connection_and_try_again": "Unable to connect. Check your connection and try again.",
      "add_photos_to_the_listing_form_before_saving": "Add photos to the listing form before saving.",
      "missing_listing_id": "Missing listing ID.",
      "this_listing_is_no_longer_available": "This listing is no longer available.",
      "you_do_not_own_this_listing_643": "You do not own this listing.",
      "this_conversation_is_not_accessible": "This conversation is not accessible.",
      "invalid_recipient_or_message": "Invalid recipient or message.",
      "this_conversation_no_longer_accepts_new_messages": "This conversation no longer accepts new messages.",
      "unable_to_upload_files": "Unable to upload files.",
      "invalid_listing": "Invalid listing.",
      "the_server_did_not_return_a_pdf": "The server did not return a PDF.",
      "invalid_date": "Invalid date.",
      "choose_a_check_in_date_from_today_and_a_check_out_date_after_check_in": "Choose a check-in date from today and a check-out date after check-in.",
      "invalid_number_of_guests": "Invalid number of guests.",
      "a_request_is_already_in_progress": "A request is already in progress.",
      "you_cannot_book_your_own_accommodation": "You cannot book your own accommodation.",
      "the_number_of_guests_exceeds_the_accommodation_s_capacity": "The number of guests exceeds the accommodation's capacity.",
      "the_length_of_stay_discount_must_be_confirmed_before_booking_656": "The length-of-stay discount must be confirmed before booking.",
      "these_dates_are_no_longer_available": "These dates are no longer available.",
      "this_booking_does_not_belong_to_you": "This booking does not belong to you.",
      "only_a_pending_request_can_be_cancelled": "Only a pending request can be cancelled.",
      "you_do_not_own_this_booking": "You do not own this booking.",
      "this_request_has_already_been_processed": "This request has already been processed.",
      "this_request_can_no_longer_be_accepted_the_account_or_listing_was_deleted": "This request can no longer be accepted: the account or listing was deleted.",
      "unable_to_load_properties": "Unable to load properties.",
      "server_unavailable": "The server is temporarily unavailable. Try again later.",
      "select_departure": "Select the check-out date",
      "select_arrival": "Select the check-in date",
      "google_sign_in": "Sign in with Google",
      "newsletter_email_required": "Enter your email address.",
      "newsletter_success": "Thank you! Your subscription has been saved.",
      "vacation_message": "Hello, I would like more information about this rental.",
      "property_message": "Hello, I am interested in your property. Is it still available?",
      "pdf_failed": "Unable to generate the PDF.",
      "invalid_conversation": "Missing or invalid conversation parameters.",
      "view_all": "View all",
      "loading_failed": "An error occurred while loading.",
      "search_failed": "Unable to search.",
      "featured_properties": "Featured properties",
      "view_listings": "View listings",
      "all_sales": "View all properties for sale",
      "all_listings": "View all listings",
      "share_failed": "Unable to share the link.",
      "all_properties": "All properties",
      "offers_only": "Offers only",
      "recently_viewed": "Recently viewed",
      "listing_brand": "LinaImmo listing",
      "property_count": "{{count}} properties",
      "published_count": "{{count}} published listings",
      "image_number": "Photo {{number}}",
      "listing_image": "{{title}} — photo {{number}}",
      "main_image": "{{title}} — main photo",
      "view_listing_named": "View listing {{title}}",
      "account_name": "Account of {{name}}",
      "increase": "Increase {{label}}",
      "decrease": "Decrease {{label}}",
      "confirmed_total": "Confirmed total: {{total}} TND. ",
      "properties_in_city": "Properties in {{city}}",
      "min_budget": "Min. {{price}} TND",
      "max_budget": "Max. {{price}} TND",
      "room_filter": "Bedrooms: {{rooms}}",
      "guest_filter": "Guests: {{guests}}",
      "offers_city": "Offers found in {{city}}",
      "network_error_detail": "Error: {{message}}",
      "http_error": "HTTP error: {{status}}",
      "photo_remove": "Remove photo",
      "previous_month": "Previous month",
      "next_month": "Next month",
      "clear_date": "Clear date",
      "recent_search_history": "Recent searches",
      "photos_total": "View all {{count}} photos",
      "error_prefix": "Error:"
    },
    "remove_from_favorites": "Remove from favorites",
    "add_to_favorites": "Add to favorites",
    "saving": "Saving...",
    "in_my_favorites": "In my favorites",
    "share": "Share",
    "messages": "Messages",
    "preparing": "Preparing...",
    "print": "Print",
    "delete": "Delete",
    "conversations": "Conversations",
    "messages.search": "Search conversations",
    "messages.deleted_listing": "Listing deleted",
    "messages.property_discussion": "About this listing",
    "messages.open_discussion": "View messages",
    "messages.delete_conversation": "Delete conversation",
    "messages.no_results": "No conversations found",
    "messages.discussion_note": "All your conversations in one place.",
    "create": {
      "address_search_required": "Please enter an address.",
      "address_not_found": "Address not found.",
      "address_search_error": "Unable to search for this address right now.",
      "address_fields_required": "Please select the city and delegation.",
      "position_unconfirmed": "Location not confirmed",
      "area_position": "Approximate delegation location, not the exact address.",
      "search_address": "Search address",
      "map_preview": "Map preview",
      "step_6": "Step 6",
      "photos_title": "Add your photos",
      "photos_description": "Add bright, clear photos to showcase your property.",
      "upload_photos": "Upload photos",
      "upload_photos_help": "Choose a main photo, then add the rooms and amenities.",
      "photo_tips_title": "Tips",
      "photo_tips": "Use clear, bright landscape photos. Avoid blurry or dark images.",
      "select_type_error": "Select the transaction and property type.",
      "title_required": "A listing title is required.",
      "surface_required": "Enter a valid area.",
      "address_required": "Enter the property address.",
      "price_required": "Enter a valid price.",
      "discount_price_error": "The discounted price must be below the original price.",
      "contact_required": "Enter your email and phone number.",
      "login_required": "You must be signed in to post a listing.",
      "images_required": "Add at least one photo.",
      "success": "Your listing has been published successfully.",
      "error": "Unable to publish the listing.",
      "description": "Enter your property details in a few steps.",
      "transaction_title": "What type of listing would you like to post?",
      "transaction_description": "Choose the transaction and property type.",
      "describe_title": "Describe your property",
      "describe_description": "Add a clear title and the main features.",
      "address_title": "Locate your property",
      "address_description": "Enter the exact address so buyers can easily locate your property.",
      "price_title": "Set the price",
      "price_description": "Enter the property price and optionally add a discount.",
      "discount_price": "Discounted price",
      "contact_title": "Your contact details",
      "contact_description": "These details will allow interested people to contact you.",
      "publish": "Publish listing"
    },
    "enterAdres": "Enter an address",
    "SelectDelegation": "Select a delegation",
    "Continuer": "Continue",
    "vacation": {
      "accommodation": "Holiday rental",
      "no_listings": "No vacation rentals available at the moment.",
      "category_required": "Select an accommodation type.",
      "address_required": "Please enter the address, city and delegation.",
      "guests_required": "The accommodation must host at least one person.",
      "price_required": "Enter a valid price.",
      "discount_error": "The discounted price must be below the regular price.",
      "contact_required": "Enter your email and phone number.",
      "login_required": "You must be signed in to post a listing.",
      "photos_required": "Add at least one photo.",
      "create_success": "Your vacation rental has been published.",
      "create_error": "Unable to publish your listing.",
      "create_title": "List a holiday rental",
      "create_description": "Present your accommodation, amenities and rates in a few steps.",
      "accommodation_title": "What type of accommodation do you offer?",
      "accommodation_description": "Select the option that matches your rental.",
      "equipment_description": "Select the amenities available in your accommodation.",
      "address_title": "Locate the accommodation",
      "address_description": "Enter the address and check the location on the map.",
      "capacity_description": "Enter the number of guests, bedrooms, beds and bathrooms.",
      "pricing_title": "Set your rates",
      "pricing_description": "Enter the daily rate and any discounts.",
      "discount_price": "Discounted price",
      "contact_description": "These details will allow guests to contact you.",
      "photos_title": "Add accommodation photos",
      "photos_description": "Choose bright photos that show the rooms and amenities.",
      "publish": "Publish rental",
      "search_description": "Discover accommodation across Tunisia for your holidays and short stays.",
      "guests_placeholder": "Number",
      "available_stays": "Available stays",
      "results_in_city": "Rentals in {{city}}",
      "all_results": "All rentals",
      "results": "results",
      "result": "result"
    },
    "close": "Close",
    "messages.view_conversations": "View conversations",
    "messages.title": "Messages",
    "messages.start": "Your conversation starts here",
    "messages.start_hint": "Ask your first question about this listing.",
    "messages.deleted_notice": "This listing has been deleted. You can still read your messages.",
    "messages.recipient_unavailable": "This recipient is no longer available. You can still read your messages.",
    "messages.keyboard_hint": "Enter to send · Shift + Enter for a new line",
    "messages.waiting_for_reply": "Waiting for a reply: you can write again as soon as the other person answers.",
    "messages.limit_consecutive": "You have already sent several messages without a reply. Wait for the other person to answer before writing again.",
    "messages.limit_new_conversations": "You have opened many new conversations today. You can still reply in your conversations; try again later to start a new one.",
    "loading": "Loading...",
    "request": {
      "load_error": "Unable to load requests.",
      "invalid_id": "Invalid request ID.",
      "update_error": "Unable to update the request.",
      "description": "View incoming requests and accept or reject bookings.",
      "empty_description": "You have no booking requests to review at the moment."
    },
    "cancelled": "Cancelled",
    "request_accepted": "Request accepted.",
    "request_cancelled": "Request rejected.",
    "refresh": "Refresh",
    "accept": "Accept",
    "reject": "Reject",
    "reservation": {
      "load_error": "Unable to load your bookings.",
      "description": "View and manage all your booking requests.",
      "empty_description": "You have no bookings to display at the moment."
    },
    "confirm": "Are you sure you want to cancel this booking?",
    "success": "Booking cancelled.",
    "failed": "Unable to cancel the booking.",
    "booking_date": "Booking",
    "messages.load_error": "Unable to load your conversations.",
    "messages.conversation_error": "Unable to load this conversation.",
    "messages.send_error": "Unable to send the message.",
    "messages.delete_confirm": "Do you want to delete this conversation?",
    "messages.delete_error": "Unable to delete this conversation.",
    "messages.login_required": "Sign-in required",
    "messages.login_description": "Sign in to view your conversations.",
    "messages.empty_description": "Your conversations with owners and users will appear here.",
    "messages.select_conversation": "Select a conversation",
    "messages.select_description": "Choose a conversation to view its messages.",
    "rooms": "Rooms",
    "sending": "Sending...",
    "options": {
      "description": "Amenities and services",
      "wifi": "Wi-Fi",
      "tv": "Tv",
      "cuisine": "Cuisine",
      "lavelinge": "Lave-linge",
      "Parking": "Parking",
      "climatisation": "Air conditioning",
      "espacedetravail": "Espace de travail",
      "picine": "Piscine",
      "barbecue": "Barbecue",
      "jardin": "Jardin",
      "accesauplage": "Accès au plage",
      "camera": "Caméra de surveillance ",
      "parking": "Parking",
      "furnished": "Furnished"
    },
    "details": "Accommodation capacity",
    "edit.invalid_id": "Invalid listing ID.",
    "edit.not_found": "This listing could not be found.",
    "edit.load_error": "Unable to retrieve this listing's information.",
    "edit.no_changes": "No changes detected.",
    "edit.success": "The listing has been updated.",
    "edit.update_error": "Unable to update the listing.",
    "edit.error_title": "Unable to edit the listing",
    "edit.back_ads": "Back to my listings",
    "edit.description": "Edit your listing details, then save your changes.",
    "edit.unsaved_changes": "Unsaved changes",
    "edit.step": "Step {{number}}",
    "edit.property_title": "Property information",
    "edit.property_description": "Edit the main details of your listing.",
    "edit.additional_title": "Additional information",
    "edit.additional_description": "Complete the property's features and additional details.",
    "edit.photos_title": "Listing photos",
    "edit.photos_description": "Keep, remove or add photos to your listing.",
    "edit.manage_photos": "Manage photos",
    "edit.manage_photos_description": "Existing photos are kept unless you delete them. You can also add new ones.",
    "edit.updating": "Updating...",
    "editVacation": {
      "load_error": "Unable to retrieve this rental's information.",
      "success": "The rental has been updated.",
      "update_error": "Unable to update the rental.",
      "error_title": "Unable to edit this rental",
      "description": "Edit your accommodation, amenities, details and photos.",
      "property_title": "Accommodation information",
      "property_description": "Edit the main details of your vacation rental.",
      "additional_title": "Additional information",
      "additional_description": "Edit the accommodation's capacity, rates and additional details.",
      "options_title": "Amenities and services",
      "options_description": "Specify the amenities available to guests.",
      "photos_title": "Accommodation photos",
      "photos_description": "Keep, remove or add photos to your rental.",
      "manage_photos_description": "Keep your existing photos or add new ones to showcase your accommodation."
    },
    "search_form": {
      "search_title": "Find your next home",
      "search_description": "Select a city, then refine your search criteria.",
      "category": "Category",
      "all_categories": "All categories",
      "hide_advanced_search": "Hide filters",
      "advanced_search": "Advanced search",
      "label": "Keyword",
      "search_placeholder": "Apartment, villa, land...",
      "rooms": "Number of rooms",
      "min_price": "Minimum price",
      "max_price": "Maximum price",
      "reset": "Reset filters",
      "search": "Search",
      "all_cities": "All cities",
      "all_delegations": "All districts",
      "select_rooms": "Number of rooms",
      "you_have": "لديك",
      "pending_notifications": "إشعارات معلقة",
      "name": "الاسم",
      "select_category": "Select a category"
    },
    "errorFetchingVacations": "Unable to load vacation rentals.",
    "cities": {
      "Tunis": "Tunis",
      "Sfax": "Sfax",
      "Kairouan": "Kairouan",
      "Ariana": "Ariana",
      "Béja": "Béja",
      "Ben Arous": "Ben Arous",
      "Bizerte": "Bizerte",
      "Gabès": "Gabès",
      "Gafsa": "Gafsa",
      "Jendouba": "Jendouba",
      "Kasserine": "Kasserine",
      "Kébili": "Kébili",
      "Kef": "Le Kef",
      "Mahdia": "Mahdia",
      "Manouba": "Manouba",
      "Médenine": "Médenine",
      "Monastir": "Monastir",
      "Nabeul": "Nabeul",
      "Sidi Bouzid": "Sidi Bouzid",
      "Siliana": "Siliana",
      "Sousse": "Sousse",
      "Tataouine": "Tataouine",
      "Tozeur": "Tozeur",
      "Zaghouan": "Zaghouan",
      "Le Kef": "Le Kef",
      "Hammamet": "Hammamet"
    },
    "delegations": {
      "Tunis": {
        "Bab El Bhar": "Bab El Bhar",
        "Bab Souika": "Bab Souika",
        "Carthage": "Carthage",
        "Cité El Khadra": "Cité El Khadra",
        "Djebel Jelloud": "Djebel Jelloud",
        "El Kabaria": "El Kabaria",
        "El Menzah": "El Menzah",
        "El Omrane": "El Omrane",
        "El Omrane Supérieur": "El Omrane Supérieur",
        "El Ouardia": "El Ouardia",
        "Ettahrir": "Ettahrir",
        "Ezzouhour": "Ezzouhour",
        "Hrairia": "Hrairia",
        "La Goulette": "La Goulette",
        "La Marsa": "La Marsa",
        "Le Bardo": "Le Bardo",
        "Le Kram": "Le Kram",
        "Médina": "Médina",
        "Séjoumi": "Séjoumi",
        "Sidi El Béchir": "Sidi El Béchir",
        "Sidi Hassine": "Sidi Hassine"
      },
      "Sfax": {
        "Sakiet Eddaier": "Sakiet Eddaier",
        "Sakiet Ezzit": "Sakiet Ezzit",
        "Sfax Ouest": "Sfax Ouest",
        "Sfax Sud": "Sfax Sud",
        "Sfax Ville": "Sfax Ville",
        "Thyna": "Thyna",
        "El Amra": "El Amra",
        "El Hencha": "El Hencha",
        "Graïba": "Graïba",
        "Jebeniana": "Jebeniana",
        "Kerkennah": "Kerkennah",
        "Mahrès": "Mahrès",
        "Menzel Chaker": "Menzel Chaker"
      },
      "Kairouan": {
        "Kairouan Nord": "Kairouan Nord",
        "Kairouan Sud": "Kairouan Sud",
        "Chebika": "Chebika",
        "Sbikha": "Sbikha",
        "Haffouz": "Haffouz",
        "Hajeb El Ayoun": "Hajeb El Ayoun",
        "Oueslatia": "Oueslatia",
        "Bou Hajla": "Bou Hajla",
        "Nasrallah": "Nasrallah",
        "Chrarda": "Chrarda"
      },
      "Ariana": {
        "Ariana Ville": "Ariana Ville",
        "Ettadhamen": "Ettadhamen",
        "Kalaat el Andalous": "Kalaat el Andalous",
        "La Soukra": "La Soukra",
        "Mnihla": "Mnihla",
        "Raoued": "Raoued",
        "Sidi Thabet": "Sidi Thabet"
      },
      "Béja": {
        "Amdoun": "Amdoun",
        "Béja Nord": "Béja Nord",
        "Béja Sud": "Béja Sud",
        "Goubellat": "Goubellat",
        "Medjez el Bab": "Medjez el Bab",
        "Nefza": "Nefza",
        "Téboursouk": "Téboursouk",
        "Testour": "Testour",
        "Thibar": "Thibar"
      },
      "Ben Arous": {
        "Ben Arous": "Ben Arous",
        "Bou Mhel el Bassatine": "Bou Mhel el Bassatine",
        "El Mourouj": "El Mourouj",
        "Ezzahra": "Ezzahra",
        "Fouchana": "Fouchana",
        "Hammam Chott": "Hammam Chott",
        "Hammam Lif": "Hammam Lif",
        "Mohamedia": "Mohamedia",
        "Mornag": "Mornag",
        "Nouvelle Medina": "Nouvelle Medina",
        "Radès": "Radès"
      },
      "Bizerte": {
        "Bizerte Nord": "Bizerte Nord",
        "Bizerte Sud": "Bizerte Sud",
        "Djoumine": "Djoumine",
        "El Alia": "El Alia",
        "Ghar El Melh": "Ghar El Melh",
        "Ghezala": "Ghezala",
        "Joumine": "Joumine",
        "Mateur": "Mateur",
        "Menzel Bourguiba": "Menzel Bourguiba",
        "Menzel Jemil": "Menzel Jemil",
        "Ras Jebel": "Ras Jebel",
        "Sejenane": "Sejenane",
        "Tinja": "Tinja",
        "Utique": "Utique",
        "Zarzouna": "Zarzouna"
      },
      "Gabès": {
        "Gabès Ville": "Gabès Ville",
        "Gabès Ouest": "Gabès Ouest",
        "Gabès Sud": "Gabès Sud",
        "Ghannouch": "Ghannouch",
        "Mareth": "Mareth",
        "Matmata": "Matmata",
        "Menzel Habib": "Menzel Habib",
        "Métouia": "Métouia",
        "Nouvelle Matmata": "Nouvelle Matmata"
      },
      "Gafsa": {
        "Belkhir": "Belkhir",
        "El Guettar": "El Guettar",
        "El Ksar": "El Ksar",
        "Gafsa Nord": "Gafsa Nord",
        "Gafsa Sud": "Gafsa Sud",
        "Mdhilla": "Mdhilla",
        "Metlaoui": "Metlaoui",
        "Moularès": "Moularès",
        "Redeyef": "Redeyef",
        "Sened": "Sened",
        "Sidi Aïch": "Sidi Aïch"
      },
      "Jendouba": {
        "Aïn Draham": "Aïn Draham",
        "Balta-Bou Aouane": "Balta-Bou Aouane",
        "Bou Salem": "Bou Salem",
        "Fernana": "Fernana",
        "Ghardimaou": "Ghardimaou",
        "Jendouba Nord": "Jendouba Nord",
        "Jendouba Sud": "Jendouba Sud",
        "Oued Meliz": "Oued Meliz",
        "Tabarka": "Tabarka"
      },
      "Kasserine": {
        "Djedeliane": "Djedeliane",
        "El Ayoun": "El Ayoun",
        "Ezzouhour": "Ezzouhour",
        "Fériana": "Fériana",
        "Foussana": "Foussana",
        "Haïdra": "Haïdra",
        "Hassi El Ferid": "Hassi El Ferid",
        "Kasserine Nord": "Kasserine Nord",
        "Kasserine Sud": "Kasserine Sud",
        "Majel Bel Abbès": "Majel Bel Abbès",
        "Sbeitla": "Sbeitla",
        "Sbiba": "Sbiba",
        "Thala": "Thala"
      },
      "Kébili": {
        "Douz Nord": "Douz Nord",
        "Douz Sud": "Douz Sud",
        "Faouar": "Faouar",
        "Kébili Nord": "Kébili Nord",
        "Kébili Sud": "Kébili Sud",
        "Souk Lahad": "Souk Lahad"
      },
      "Le Kef": {
        "Dahmani": "Dahmani",
        "Jérissa": "Jérissa",
        "El Ksour": "El Ksour",
        "Le Kef Est": "Le Kef Est",
        "Le Kef Ouest": "Le Kef Ouest",
        "Ksour": "Ksour",
        "Nebeur": "Nebeur",
        "Sakiet Sidi Youssef": "Sakiet Sidi Youssef",
        "Sers": "Sers",
        "Tajerouine": "Tajerouine"
      },
      "Mahdia": {
        "Bou Merdes": "Bou Merdes",
        "Chorbane": "Chorbane",
        "El Jem": "El Jem",
        "Essouassi": "Essouassi",
        "Hebira": "Hebira",
        "Ksour Essef": "Ksour Essef",
        "Mahdia": "Mahdia",
        "Melloulech": "Melloulech",
        "Ouled Chamekh": "Ouled Chamekh",
        "Sidi Alouane": "Sidi Alouane"
      },
      "Manouba": {
        "Borj El Amri": "Borj El Amri",
        "Douar Hicher": "Douar Hicher",
        "El Battan": "El Battan",
        "Jedaida": "Jedaida",
        "La Manouba": "La Manouba",
        "Mornaguia": "Mornaguia",
        "Oued Ellil": "Oued Ellil",
        "Tebourba": "Tebourba"
      },
      "Médenine": {
        "Ben Gardane": "Ben Gardane",
        "Beni Khedache": "Beni Khedache",
        "Djerba - Ajim": "Djerba - Ajim",
        "Djerba - Houmt Souk": "Djerba - Houmt Souk",
        "Djerba - Midoun": "Djerba - Midoun",
        "Médenine Nord": "Médenine Nord",
        "Médenine Sud": "Médenine Sud",
        "Sidi Makhlouf": "Sidi Makhlouf",
        "Zarzis": "Zarzis"
      },
      "Monastir": {
        "Bekalta": "Bekalta",
        "Bembla": "Bembla",
        "Beni Hassen": "Beni Hassen",
        "Jemmal": "Jemmal",
        "Ksar Hellal": "Ksar Hellal",
        "Ksibet el Mediouni": "Ksibet el Mediouni",
        "Moknine": "Moknine",
        "Monastir": "Monastir",
        "Ouerdanine": "Ouerdanine",
        "Sahline": "Sahline",
        "Sayada-Lamta-Bou Hjar": "Sayada-Lamta-Bou Hjar",
        "Teboulba": "Teboulba",
        "Zéramdine": "Zéramdine"
      },
      "Nabeul": {
        "Béni Khalled": "Béni Khalled",
        "Béni Khiar": "Béni Khiar",
        "Bou Argoub": "Bou Argoub",
        "Dar Chaâbane El Fehri": "Dar Chaâbane El Fehri",
        "El Haouaria": "El Haouaria",
        "El Mida": "El Mida",
        "Grombalia": "Grombalia",
        "Hammam Ghezèze": "Hammam Ghezèze",
        "Hammamet": "Hammamet",
        "Kélibia": "Kélibia",
        "Korba": "Korba",
        "Menzel Bouzelfa": "Menzel Bouzelfa",
        "Menzel Temime": "Menzel Temime",
        "Nabeul": "Nabeul",
        "Soliman": "Soliman",
        "Takelsa": "Takelsa"
      },
      "Sidi Bouzid": {
        "Bir El Hafey": "Bir El Hafey",
        "Cebbala Ouled Asker": "Cebbala Ouled Asker",
        "Jilma": "Jilma",
        "Meknassy": "Meknassy",
        "Mezzouna": "Mezzouna",
        "Menzel Bouzaiane": "Menzel Bouzaiane",
        "Ouled Haffouz": "Ouled Haffouz",
        "Regueb": "Regueb",
        "Sidi Ali Ben Aoun": "Sidi Ali Ben Aoun",
        "Sidi Bouzid Est": "Sidi Bouzid Est",
        "Sidi Bouzid Ouest": "Sidi Bouzid Ouest",
        "Souk Jedid": "Souk Jedid"
      },
      "Siliana": {
        "Bargou": "Bargou",
        "Bou Arada": "Bou Arada",
        "El Aroussa": "El Aroussa",
        "Gaâfour": "Gaâfour",
        "El Krib": "El Krib",
        "Makthar": "Makthar",
        "Rouhia": "Rouhia",
        "Sidi Bou Rouis": "Sidi Bou Rouis",
        "Siliana Nord": "Siliana Nord",
        "Siliana Sud": "Siliana Sud",
        "Kesra": "Kesra"
      },
      "Sousse": {
        "Bouhsina": "Bouhsina",
        "Chott Meriem": "Chott Meriem",
        "Kantaoui": "Kantaoui",
        "Khzema": "Khzema",
        "Messaadine": "Messaadine",
        "Swisse": "Swisse",
        "Tafala": "Tafala",
        "Ksiba": "Ksiba",
        "Akouda": "Akouda",
        "Bouficha": "Bouficha",
        "Enfidha": "Enfidha",
        "Hammam Sousse": "Hammam Sousse",
        "Hergla": "Hergla",
        "Kalâa Kebira": "Kalâa Kebira",
        "Kalâa Seghira": "Kalâa Seghira",
        "Kondar": "Kondar",
        "Msaken": "Msaken",
        "Sidi Bou Ali": "Sidi Bou Ali",
        "Sidi El Hani": "Sidi El Hani",
        "Sousse Jawhara": "Sousse Jawhara",
        "Sousse Médina": "Sousse Médina",
        "Sousse Riadh": "Sousse Riadh",
        "Sousse Sidi Abdelhamid": "Sousse Sidi Abdelhamid",
        "Sahloul": "Sahloul",
        "Cité Zouhour": "Cité Zouhour",
        "Thrayat": "Thrayat",
        "Zawiya": "Zawiya",
        "Cité Manazah": "Cité Manazah"
      },
      "Tataouine": {
        "Bir Lahmar": "Bir Lahmar",
        "Dehiba": "Dehiba",
        "Ghomrassen": "Ghomrassen",
        "Remada": "Remada",
        "Samar": "Samar",
        "Tataouine Nord": "Tataouine Nord",
        "Tataouine Sud": "Tataouine Sud"
      },
      "Tozeur": {
        "Degache": "Degache",
        "Hamet Jerid": "Hamet Jerid",
        "Nefta": "Nefta",
        "Tozeur": "Tozeur",
        "Tameghza": "Tameghza"
      },
      "Zaghouan": {
        "Bir Mcherga": "Bir Mcherga",
        "El Fahs": "El Fahs",
        "Nadhour": "Nadhour",
        "Saouaf": "Saouaf",
        "Zaghouan": "Zaghouan",
        "Zriba": "Zriba"
      },
      "Kef": {
        "Dahmani": "Dahmani",
        "Jérissa": "Jérissa",
        "El Ksour": "El Ksour",
        "Le Kef Est": "Le Kef Est",
        "Le Kef Ouest": "Le Kef Ouest",
        "Ksour": "Ksour",
        "Nebeur": "Nebeur",
        "Sakiet Sidi Youssef": "Sakiet Sidi Youssef",
        "Sers": "Sers",
        "Tajerouine": "Tajerouine",
        "Kef Est": "Le Kef Est",
        "Kef Ouest": "Le Kef Ouest"
      }
    },
    "room": "Chambre",
    "maps": "Locate your property",
    "you_have": "You have",
    "pending_notifications": "pending notifications",
    "Profile": {
      "succes": "تم الحذف بنجاح",
      "echec": "فشلت عملية الحذف"
    },
    "m²": "m²",
    "sell - rent": "بيع/ إيجار",
    "non": "No",
    "search": "أدخل العنوان أو المدينة في تونس",
    "contacts": "Contact details",
    "Coût": "Cost",
    "cost": "Cost",
    "name": "Name",
    "describe_property": "Describe your property",
    "upload_images": "Add photos",
    "locate_property": "Locate your property",
    "localize_property": "Locate your property",
    "select_city": "Select a city",
    "select_delegation": "Select a district",
    "login": "Sign in",
    "signup": "Create an account",
    "categories": {
      "apartment": "Apartment",
      "house": "House",
      "commercial": "Commercial",
      "land": "Land",
      "others": "Other"
    },
    "rooms.bedrooms": "Bedrooms",
    "rooms.studio": "Studio",
    "rooms.two": "2 rooms",
    "rooms.three": "3 rooms",
    "rooms.four": "4 rooms",
    "rooms.five": "5 rooms",
    "rooms.six_or_more": "6 or more rooms",
    "appartement": "Apartment",
    "maison": "House",
    "terrain": "Land",
    "autres": "Other",
    "sale": "Sale"
  }
};
